module.exports = __webpack_public_path__ + "static/Private-Vehicle-c8bf1a70ca7046e02741435ca322730d.svg";